import React, { useEffect, useMemo, useState } from 'react';

import EnsureId from 'psims/react/pages/primary-pages/data-submissions/shared/ensure-id';
import useSubmissionLoadState from 'psims/react/pages/primary-pages/data-submissions/shared/use-submission-load-state';
import LoadingSubmission from 'psims/react/pages/primary-pages/data-submissions/shared/loading-submission';
import LoadSubmissionFailed from 'psims/react/pages/primary-pages/data-submissions/shared/load-submission-failed';
import ImporterAnnualActivityEditor from './importer-annual-activity-editor';
import useImporterAnnualActivityAPI, { UseImporterAnnualActivityAPI } from './use-importer-annual-activity-api';

interface MsoAnnualActivityImporterProps {
    id: number;
}

const MsoAnnualActivityImporter = (props: MsoAnnualActivityImporterProps) => {
    const vm = useVM(props);

    switch(vm.loadState) {
        case 'error':
            return <LoadSubmissionFailed submissionName='MSO importer' />
        case 'loaded':
            return <ImporterAnnualActivityEditor
                // TODO: should type assert apiCtrl
                apiCtrl={vm.apiCtrl as PopulatedProps<UseImporterAnnualActivityAPI, 'submission'>}
            />;
        default:
            return <LoadingSubmission submissionName='MSO importer' />;

    }
}

function useVM(props: MsoAnnualActivityImporterProps) {
    const apiCtrl = useImporterAnnualActivityAPI({id: props.id});
    const [loaded, setLoaded] = useState(false);

    const ready = useMemo(() => {
        return loaded;
    }, [loaded]);

    const loadState = useSubmissionLoadState({submission: apiCtrl.submission, isDepsReady: ready, loadStatus: apiCtrl.loadStatus})

    useEffect(() => {
        if (apiCtrl.loadStatus === 'fetched') {
            setLoaded(true);
        }
    }, [apiCtrl.loadStatus]);

    return {
        apiCtrl,
        loadState: loadState as typeof loadState,
    }
}

const Page = (props: MsoAnnualActivityImporterProps) => <EnsureId id={props.id} Component={MsoAnnualActivityImporter} />;

export default Page;
